<template>
  <div id="app" class="Site">
    <head-banner v-if="header_show"></head-banner>
    <router-view class="Site-content" v-on:public_header="public_header" v-on:public_footer="public_footer" />
    <foot-banner v-if="footer_show"></foot-banner>
  </div>
</template>

<script>
import HeadBanner from "@/components/HeadBanner/index";
import FootBanner from "@/components/FootBanner/index";
// import { queyrList } from "@/api/map/index";
export default {
  name: "App",
  components: { FootBanner, HeadBanner },
  data() {
    return {
      header_show: true,
      footer_show:true,
    };
  },
  methods: {
    //是否显示头部
    public_header (bool) {
      this.header_show = bool;
    },
    // 是否显示底部
    public_footer(bool){
      this.footer_show = bool;
    }
  },
  mounted() {
  },
};
</script>

<style>
/* 表格单元格为null时候 数据显示无 */
.el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: '无';
}
/* 步骤条样式 */
.el-step__title.is-wait {
  color: #000;
}
.el-step.is-simple .el-step__title{
  font-size: 15px;
}
.el-step__icon.is-text{
  border: none;
}
/* 当前步骤样式 */
.el-step__title.is-process {
  font-weight: 700;
  color: #0090FF;
}
/* 已完成步骤 */
.el-step__title.is-finish {
  color: #000;
}
/* 个人中心侧边栏样式 */
.el-tabs__item{
  font-size:16px;
  font-weight: 550;
}
/* 个人中心位置*/
.el-dropdown {
  display: inline-block;
  position: absolute;
  color: #606266;
  font-size: 14px;
  right: 0;
  top: 30px;
}
/*上传组件图标样式
.el-icon-plus:before {
  content: "\e6d9";
  background-color: #1876FB;
  color: #fff;
  border-radius: 50%;
}*/
/*上传组件样式*/
.el-upload--picture-card{
  width:100%;
  height: auto;
  line-height: 136px;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  /* margin-top: 60px; 
  background: url(http://www.hanyuan.gov.cn/v2/images/head_bg.jpg) no-repeat center 0;*/
}
.Site-content {
  flex: 1;
  padding-bottom: 60px;
}
body,
p {
  margin: 0;
}

a {
  color: #000;
  text-decoration: none;
}

ul,
li {
  margin: 0;
  padding: 0;
}

li {
  list-style: none;
}
</style>
